<template>
  <div class="app-inner">
    <el-form :inline="true">
      <el-form-item label="考勤时段">
       <el-date-picker
        v-model="time"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="primary" @click="exportList">导出</el-button>
      </el-form-item>
    </el-form>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange"
    >
    </table-list>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import { queryAll, compAttendanceExport } from '@/api/compAttendance.js'
import { AttendanceStatus } from '@/utils/constants'
export default {
  data () {
    return {
      time: '',
      page: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      tableData: [],
      columnDefs: [
        { label: '姓名', prop: 'chineseName' },
        { label: '上班时间', prop: 'arrivalTime' },
        { label: '下班时间', prop: 'leaveTime' },
        {
          label: '打卡状态',
          prop: 'userName',
          formatter: (row) => {
            let status = AttendanceStatus.find(item => item.value === row.status)
            return status?.label || ''
          }
        },
        { label: '打卡日期', prop: 'checkDate' },
      ]
    }
  },
  components: {
    TableList
  },
  methods: {
    query () {
      this.page = 1
      this.getData()
    },
    getData () {
      this.loading = true
      queryAll({
        pageNum: this.page,
        pageSize: this.pageSize,
        startTime: this.time?.[0] || '',
        endTime: this.time?.[1] || ''
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
      })
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    exportList () {
      compAttendanceExport({
        startTime: this.time?.[0] || '',
        endTime: this.time?.[1] || ''
      }).then(res => {
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        const elink = document.createElement("a");
        elink.download = '考勤记录.xls';
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      })
    }
  },
  mounted () {
    this.query()
  }
}
</script>
